import { Injectable } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadLegalDocuments, loadLegalDocumentsSuccess, loadLegalDocumentsFailure } from '@app/core/store/legal-documents/actions';
import { of } from 'rxjs';
import { ApiLegalDocumentsCacheService } from '@app/core/legal-documents/api-legal-documents-cache.service';

@Injectable()
export class LegalDocumentsEffects {

  public loadLegalDocuments$ = createEffect(() => this.actions$.pipe(
    ofType(loadLegalDocuments),
    switchMap(() => this.apiLegalDocumentsCacheService.getDocuments().pipe(
        map(legalDocuments => loadLegalDocumentsSuccess({ legalDocuments })),
        catchError(error => of(loadLegalDocumentsFailure({ error: error.toString() }))),
      ),
    )));

  constructor(private actions$: Actions,
              private apiLegalDocumentsCacheService: ApiLegalDocumentsCacheService) {}

}
